(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
class PivotCollectionTabs extends HTMLElement {
  constructor() {
    super()
    this.ACTIVE_CLASS = 'pivot-collection-tabs__active'
    this.ACTIVE_TAB_CLASS = 'pivot-collection-tabs__tab--active'
    this.tabs = [...this.querySelectorAll('.pivot-collection-tabs__tab')]
    this.isButtonsStyle = this.classList.contains('pivot-menu-buttons')
  }
  connectedCallback() {
    if(!this.isConnected) return
    this.tabs.forEach(btn => btn.addEventListener('click', e => {
      const currentTab = this.querySelector(`.pivot-collection-tabs__tab.${this.ACTIVE_TAB_CLASS}`)
      const newTab = e.target.closest('button')
      const currentSection = this.querySelector(`.pivot-collection-tabs__collection-carousel.${this.ACTIVE_CLASS}`)
      const newActiveSection = this.querySelector(`.pivot-collection-tabs__collection-carousel#${newTab.dataset.tab}`)
      if(currentSection) currentSection.classList.remove(this.ACTIVE_CLASS)
      if(currentTab) {
        currentTab.classList.remove(this.ACTIVE_TAB_CLASS)
        if(this.isButtonsStyle) currentTab.classList.add('button--secondary')
      }
      if(newActiveSection) newActiveSection.classList.add(this.ACTIVE_CLASS)
      if(newTab) {
        newTab.classList.add(this.ACTIVE_TAB_CLASS)
        if(this.isButtonsStyle) newTab.classList.remove('button--secondary')
      }
    }))
  }
}
if(!customElements.get('pivot-collection-tabs')) {
  customElements.define('pivot-collection-tabs', PivotCollectionTabs)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-store-attributes"] && !Shopify.designMode) return;
  try {
    
class PivotStoreAttributes extends HTMLElement {
  async connectedCallback() {
    if(!this.isConnected) return 
    await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
    const isAutoWidth = this.getAttribute('auto-width')
    const perPage = this.dataset.perPage
    this.splide = new Splide(this,{
      autoWidth: isAutoWidth !== null,
      perPage: Number(perPage),
      arrows: false,
      pagination: false,
      // trimSpace: true,
      // focus: 'center',
    })
    this.splide.mount()
  }
}
if(!customElements.get("pivot-store-attributes")) {
  customElements.define("pivot-store-attributes", PivotStoreAttributes)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stoh-freedom-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stoh-freedom-hero')) {
    customElements.define('stoh-freedom-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        this.track = this.querySelector('.stoh-freedom__track');
        this.slides = [...this.querySelectorAll('.stoh-freedom__slide')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = true;
        this.touching = false;
        const pause = this.querySelector('[data-pause]');
        const syncPause = () => {
          if (!pause) return;
          pause.setAttribute('aria-pressed', String(this.paused));
          pause.setAttribute('aria-label', this.paused ? pause.dataset.labelPlay : pause.dataset.labelPause);
          pause.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
        };
        this.fitSlide = () => {
          this.track.style.removeProperty('height');
        };
        this.update = () => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.fitSlide();
          this.dots.forEach((dot, i) => i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
          this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2, '0');
        };
        this.go = (index, manual = false) => {
          if (manual) this.startTimer();
          const next = (index + this.slides.length) % this.slides.length;
          this.track.scrollTo({ left: next * this.track.clientWidth, behavior: index < 0 || index >= this.slides.length || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.track.addEventListener('scroll', this.update, { ...opts, passive: true });
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), opts);
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), opts);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.index), true), opts));
        pause?.addEventListener('click', () => { this.paused = !this.paused; syncPause(); this.startTimer(); }, opts);
        this.addEventListener('touchstart', () => { this.touching = true; }, { ...opts, passive: true });
        const endTouch = () => { this.touching = false; this.startTimer(); };
        this.addEventListener('touchend', endTouch, { ...opts, passive: true });
        this.addEventListener('touchcancel', endTouch, { ...opts, passive: true });
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1, true); }
        }, opts);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.paused = true; syncPause(); this.go(index, true); }
        }, opts);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        this.resizer = new ResizeObserver(() => { this.fitSlide(); this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }); });
        this.resizer.observe(this.track);
        this.slides.forEach(slide => this.resizer.observe(slide));
        this.fitSlide();
        this.startTimer = () => {
          clearInterval(this.timer);
          if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
          this.timer = setInterval(() => {
            const keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
            if (!this.paused && !this.touching && this.visible && !document.hidden && !keyboardFocus) this.go(this.index + 1);
          }, Number(this.dataset.interval) || 10000);
        };
        this.startTimer();
        syncPause();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizer?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stoh-halloween-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stoh-halloween-hero')) {
  customElements.define('stoh-halloween-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.track = this.querySelector('.halo__track');
      this.slides = [...this.querySelectorAll('.halo__slide')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = true;
      this.touching = false;
      this.mobile = matchMedia('(max-width:1100px)');
      this.syncHeight = () => {
        if (!this.mobile.matches) {
          this.track.style.removeProperty('height');
          return;
        }
        const height = Math.ceil(this.slides[this.index]?.getBoundingClientRect().height || 0);
        if (height && this.track.style.height !== `${height}px`) this.track.style.height = `${height}px`;
      };
      this.mobile.addEventListener('change',this.syncHeight,options);
      const pause = this.querySelector('[data-pause]');
      const syncPause = () => {
        if (!pause) return;
        pause.setAttribute('aria-pressed',String(this.paused));
        pause.setAttribute('aria-label',this.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
      };
      this.startTimer = () => {
        clearInterval(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        this.timer = setInterval(() => {
          const focus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          if (!this.paused && !this.touching && this.visible && !document.hidden && !focus) this.go(this.index + 1);
        },Number(this.dataset.interval) || 10000);
      };
      this.update = () => {
        this.index = Math.max(0,Math.min(this.slides.length - 1,Math.round(this.track.scrollLeft / this.track.clientWidth)));
        this.dots.forEach((dot,index) => index === this.index ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current'));
        this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2,'0');
        this.syncHeight();
      };
      this.go = (index,manual=false) => {
        if (manual) this.startTimer();
        const next = (index + this.slides.length) % this.slides.length;
        const instant = index < 0 || index >= this.slides.length || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left:next * this.track.clientWidth, behavior:instant ? 'instant' : 'smooth' });
      };
      this.track.addEventListener('scroll',this.update,{ ...options,passive:true });
      this.querySelector('[data-prev]').addEventListener('click',() => this.go(this.index - 1,true),options);
      this.querySelector('[data-next]').addEventListener('click',() => this.go(this.index + 1,true),options);
      this.dots.forEach(dot => dot.addEventListener('click',() => this.go(Number(dot.dataset.index),true),options));
      pause?.addEventListener('click',() => { this.paused = !this.paused; syncPause(); this.startTimer(); },options);
      this.addEventListener('touchstart',() => { this.touching = true; },{ ...options,passive:true });
      const endTouch = () => { this.touching = false; this.startTimer(); };
      this.addEventListener('touchend',endTouch,{ ...options,passive:true });
      this.addEventListener('touchcancel',endTouch,{ ...options,passive:true });
      this.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1,true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1,true); }
      },options);
      document.addEventListener('shopify:block:select',event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; syncPause(); this.go(index,true); }
      },options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      this.resizer = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.track.scrollTo({ left:this.index * width,behavior:'instant' });
        }
        this.syncHeight();
      });
      this.resizer.observe(this.track);
      this.slides.forEach(slide => this.resizer.observe(slide));
      this.syncHeight();
      this.startTimer();
      syncPause();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resizer?.disconnect();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
